/**
 * Стикер на доске (не ArchiMate Note/Label): квадрат как в Miro,
 * светло-жёлтая заливка, текст по центру, лёгкая тень.
 */
import ArchimateNodeType from '../ArchimateNodeType';
import {textAlignToLabelAttrs} from '../textAlignUtil';
import {
	STICKER,
	STICKER_SHAPE_ID,
	STICKER_DEFAULT_SIZE,
	DEFAULT_STICKER_COLOR,
} from '../../util/CanvasNodeTypes';

export default class StickerNodeType extends ArchimateNodeType {
	static get typeName() {
		return STICKER;
	}

	get shapeId() {
		return STICKER_SHAPE_ID;
	}

	get defaultSize() {
		return STICKER_DEFAULT_SIZE;
	}

	canConnectTo() {
		return false;
	}

	getAllowedRelationshipTypes() {
		return [];
	}

	get canBeParent() {
		return false;
	}

	getDefaultFillColor(customFill) {
		return customFill || DEFAULT_STICKER_COLOR;
	}

	getDefaultLineColor(customLine) {
		return customLine || 'none';
	}

	buildNodeConfig(_pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor, textAlign} = options;
		const align = textAlignToLabelAttrs(textAlign, {
			defaultHorizontal: 'center',
			defaultVertical: 'middle',
		});
		const w = width ?? STICKER_DEFAULT_SIZE.width;
		const h = height ?? STICKER_DEFAULT_SIZE.height;
		const stroke = lineColor && lineColor !== 'none' ? lineColor : 'none';
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: {
				shadow: {
					refWidth: '100%',
					refHeight: '100%',
					x: 2,
					y: 3,
					rx: 3,
					ry: 3,
					fill: 'rgba(0,0,0,0.16)',
					stroke: 'none',
				},
				body: {
					refWidth: '100%',
					refHeight: '100%',
					rx: 3,
					ry: 3,
					fill: fillColor ?? DEFAULT_STICKER_COLOR,
					stroke,
					strokeWidth: stroke === 'none' ? 0 : 1,
					magnet: false,
				},
				label: {
					text: label ?? '',
					fontSize: 13,
					fill: '#333333',
					...align,
					textWrap: {width: -20, height: -20, ellipsis: true, breakWord: true},
				},
			},
		};
	}
}
